import React from 'react';
import { Link } from 'react-router-dom';
import {
  Page,
  Hero,
  HeroContent,
  HeroTag,
  HeroHighlights,
  Section,
  SectionTitle,
  SectionText,
  SectionGrid,
  Card,
  List,
  Callout,
} from './InfoPageStyles';

const CodexActivities = () => (
  <Page>
    <Hero>
      <HeroContent>
        <HeroTag>About</HeroTag>
        <h1>Food Safety Activites and Standard Practices</h1>
        <p>
          FAL coordinates Liberia's participation in the Food Safety Activites and Standard 
          Practices Alimentarius Commission and helps align national standards with international 
          food safety guidance. The program brings together regulators, laboratories, and industry partners to keep standards science-based and locally relevant.
        </p>
        <HeroHighlights>
          <li>Coordinates the National Food Safety Activites and Standard Practices Committee and technical working groups.</li>
          <li>Supports adoption of Food Safety Activites and Standard Practices for labeling, hygiene, and contaminants.</li>
          <li>Builds capacity for inspectors, laboratories, and food businesses.</li>
        </HeroHighlights>
      </HeroContent>
    </Hero>

    <Section>
      <SectionTitle>National Codex program</SectionTitle>
      <SectionText>
        The Codex program strengthens collaboration across ministries, academia, and the private
        sector so Liberia can respond to emerging food safety risks and expand safe trade.
      </SectionText>
      <SectionGrid>
        <Card>
          <h3>Standards review</h3>
          <p>
            Technical groups review Codex texts and recommend national adoption or adaptation.
          </p>
        </Card>
        <Card>
          <h3>Capacity building</h3>
          <p>
            Training and mentorship programs equip inspectors, labs, and businesses with current
            food safety practices.
          </p>
        </Card>
        <Card>
          <h3>Stakeholder engagement</h3>
          <p>
            Regular consultations ensure national standards reflect consumer needs and market
            realities.
          </p>
        </Card>
      </SectionGrid>
    </Section>

    <Section>
      <SectionTitle>Current focus areas</SectionTitle>
      <List>
        <li>Food hygiene and safe processing practices.</li>
        <li>Labeling, nutrition information, and claims.</li>
        <li>Monitoring contaminants, residues, and adulteration.</li>
        <li>Strengthening surveillance and rapid alert systems.</li>
      </List>
      <Callout>
        <strong>Partner with FAL on Codex initiatives.</strong>
        <span>
          We welcome institutions and industry groups that want to contribute to standards and
          training programs.
        </span>
        <div>
          <Link to="/partnerships">See partnerships</Link> | <Link to="/contact">Get in touch</Link>
        </div>
      </Callout>
    </Section>
  </Page>
);

export default CodexActivities;
